/**
 * FAQ Redesign module.
 * Provides smooth height and opacity transitions for details elements using Web Animations API.
 * Also handles exclusive (single-open) accordion behavior.
 *
 * @param {HTMLElement} el - Root module element (.redesign-faq)
 */
const SELECTORS = {
  item: '.redesign-faq__item',
  question: '.redesign-faq__question',
  answer: '.redesign-faq__answer'
}

export default (el) => {
  const items = el.querySelectorAll(SELECTORS.item)

  items.forEach((item) => {
    const summary = item.querySelector(SELECTORS.question)
    const answer = item.querySelector(SELECTORS.answer)

    if (!summary || !answer) return

    summary.addEventListener('click', (e) => {
      e.preventDefault()

      // Prevent interaction if currently animating
      if (item.dataset.animating) {
        return
      }

      if (item.open) {
        closeItem(item, answer)
      } else {
        openItem(item, answer)
      }
    })
  })

  function openItem(item, answer) {
    // 1. Set open to true so content is rendered and scrollHeight is readable
    item.open = true

    // 2. Exclusive group behavior (close other open items in the same group)
    const groupName = item.getAttribute('name')
    if (groupName) {
      items.forEach((otherItem) => {
        if (
          otherItem !== item &&
          otherItem.getAttribute('name') === groupName &&
          otherItem.open &&
          !otherItem.dataset.animating
        ) {
          const otherAnswer = otherItem.querySelector(SELECTORS.answer)
          if (otherAnswer) {
            closeItem(otherItem, otherAnswer)
          } else {
            otherItem.open = false
          }
        }
      })
    }

    const startHeight = 0
    const endHeight = answer.scrollHeight

    answer.style.overflow = 'hidden'
    item.dataset.animating = 'true'

    const animation = answer.animate(
      [
        { height: `${startHeight}px`, opacity: 0 },
        { height: `${endHeight}px`, opacity: 1 }
      ],
      {
        duration: 250,
        easing: 'ease-out'
      }
    )

    animation.onfinish = () => {
      answer.style.overflow = ''
      delete item.dataset.animating
    }
  }

  function closeItem(item, answer) {
    const startHeight = answer.scrollHeight
    const endHeight = 0

    answer.style.overflow = 'hidden'
    item.dataset.animating = 'true'

    const animation = answer.animate(
      [
        { height: `${startHeight}px`, opacity: 1 },
        { height: `${endHeight}px`, opacity: 0 }
      ],
      {
        duration: 220,
        easing: 'ease-out'
      }
    )

    animation.onfinish = () => {
      item.open = false
      answer.style.overflow = ''
      delete item.dataset.animating
    }
  }
}
